
import { DEV_LOCAL, DEV_AWS, PROD_AWS, PROD_LOCAL } from "../../lib/constants";

const is_development_mode = config => {
  return config.env === DEV_AWS || config.env === DEV_LOCAL;
};

const is_production_mode = config => {
  return config.env === PROD_LOCAL || config.env === PROD_AWS;
};

const is_local_mode = config => {
  return config.env === PROD_LOCAL || config.env === DEV_LOCAL;
}

export { is_development_mode, is_production_mode, is_local_mode };
